<template>
	<div id="app">
		<map-view></map-view>
		<map-tool></map-tool>
	</div>
</template>

<script>
	import mapView from './components/mapView.vue'
	import mapTool from './components/tool/index.vue'
	import Vue from 'vue'
	import bus from './script/plugin/bus'
	export default {
		name: 'app',
		components: {
			mapView,
			mapTool
		},
		created() {
			Vue.prototype.bus = bus
		}
	}
</script>

<style lang="less">
	@import "./assets/app.css";
</style>



// WEBPACK FOOTER //
// src/App.vue